import React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "../authContext";
import { isLocal } from "../../../config/env";

const isAmptransEmail = (email) =>
  String(email || "")
    .trim()
    .toLowerCase()
    .endsWith("@amptrans.net");

export default function EvDemoGate({ children }) {
  const { currentUser } = useAuth();
  const allowed = isLocal && isAmptransEmail(currentUser?.email);

  if (!allowed) {
    return <Navigate to="/home" replace />;
  }
  return children;
}
